import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { parseCookies, setCookie } from 'nookies';
import { Router as RouterType } from 'next/router';
import Head from 'next/head';
import { PrismicProvider } from '@prismicio/react';
import { prismicLinkResolver } from '@store/lib/prismic';
import GlobalStyles from '@store/styles/GlobalStyles';
import { SEO } from '@store/components/SEO';
import { UserContextProvider } from '@store/contexts/UserContext';
import { trackPageView } from '@yoweb/utils/analytics/google';
import { runMocks } from '@yoweb/utils/common';
import { initRealUserMonitoring } from '@yoweb/utils/datadog';
import { StoreIntlProvider } from '@store/contexts/StoreIntlProvider';
import { isServerRendered } from '@yoweb/utils/isServerRendered';
import { isDefined } from '@yoweb/utils/isDefined';
import scroll from '@yoweb/utils/scroll';
import { useLocaleTheme } from '@yoweb/ui/hooks/useLocaleTheme';
import { FacebookPixel } from '@yoweb/ui/components/FacebookPixel';
import { getAspenLayout } from '@store/components/layouts/AspenLayout';
import { getMarketingLayout } from '@store/components/layouts/MarketingLayout';
import { getSimpleLayout } from '@store/components/layouts/SimpleLayout'; // Note: rather than in an `import()` so that it's loaded via `rel="preload"`

import '@yoweb/ui/styles/nprogress.css';
import '@yoweb/ui/styles/react-datepicker.css';
import { createStoreExternalConfigState, Provider as ExternalConfigProvider } from '@store/contexts/ExternalConfig';
import { CASUAL_PRECISION_COOKIE } from '@store/constants/analyticEvents';
import AuthGuard from '@store/components/AuthGuard';
import { UNIQUE_CUSTOMER_ELEMENT_ID } from '@store/constants/app';
import { init as initBrowserMixpanel } from '@yoweb/utils/analytics/mixpanel';
import { LinkProvider } from '@yoweb/ui/components/Link';
import { usePersistedQueryParameters } from '@store/hooks/usePersistedQueryParameters';
import { defaultStickyQueryParamConfiguration } from '@store/lib/persistedQueryParameters';
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var progress;

if (!isServerRendered) {
  void loadNProgress();
}

function loadNProgress() {
  return _loadNProgress.apply(this, arguments);
}

function _loadNProgress() {
  _loadNProgress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return import('nprogress');

          case 2:
            progress = _context3.sent;
            progress.configure({
              showSpinner: false
            });

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _loadNProgress.apply(this, arguments);
}

RouterType.events.on('routeChangeStart', function () {
  var _progress;

  return (_progress = progress) === null || _progress === void 0 ? void 0 : _progress.start();
});
RouterType.events.on('routeChangeError', function () {
  var _progress2;

  return (_progress2 = progress) === null || _progress2 === void 0 ? void 0 : _progress2.done();
});
RouterType.events.on('routeChangeComplete', function () {
  var _progress3;

  return (_progress3 = progress) === null || _progress3 === void 0 ? void 0 : _progress3.done();
});

/**
 * A wrapper over every page that's used to initialize and set the general page layout.
 */
var StoreApp = function StoreApp(_ref) {
  var _Component$layout, _pageProps$i18nextPag;

  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      router = _ref.router,
      err = _ref.err;
  var _pageProps$externalCo = pageProps.externalConfigState,
      env = _pageProps$externalCo.env,
      datadog = _pageProps$externalCo.datadog,
      facebook = _pageProps$externalCo.facebook,
      mixpanel = _pageProps$externalCo.mixpanel;
  void initBrowserMixpanel({
    requireCookie: mixpanel.requireCookie,
    token: mixpanel.token,
    proxyUrl: mixpanel.proxyUrl,
    cookieDomain: mixpanel.domain,

    /* set flushInterval to immediate so we can verify immediately in cypress */
    batchFlushInterval: process.env.NEXT_PUBLIC_API_MOCKS === 'true' ? 0 : 5000
  });

  var _useState = useState(!runMocks),
      mocksReady = _useState[0],
      setMocksReady = _useState[1];

  var theme = useLocaleTheme(router.locale);
  usePersistedQueryParameters(defaultStickyQueryParamConfiguration);
  useEffect(function () {
    var handleRouteChange = function handleRouteChange(url) {
      trackPageView(url);
    };

    if (process.env.NEXT_PUBLIC_API_MOCKS === 'true') {
      var initializeMockServer = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var mocks;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return import('@store/mocking');

                case 2:
                  mocks = _context.sent;
                  _context.next = 5;
                  return mocks.startClientMocks();

                case 5:
                  setMocksReady(true);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function initializeMockServer() {
          return _ref2.apply(this, arguments);
        };
      }();

      void initializeMockServer();
    } else {
      void initRealUserMonitoring({
        appName: 'store',
        appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
        env: env,
        datadog: datadog
      });
    }

    router.events.on('routeChangeComplete', handleRouteChange);
    return function () {
      router.events.off('routeChangeComplete', handleRouteChange);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.events]);
  useEffect(function () {
    scroll.init(); // Store unique ID for user in cookie, and dataLayer for analytics

    var cookies = parseCookies();

    if (!cookies[CASUAL_PRECISION_COOKIE]) {
      var _document$getElementB;

      var customerId = (_document$getElementB = document.getElementById(UNIQUE_CUSTOMER_ELEMENT_ID)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.getAttribute('content');

      if (customerId) {
        var _window$dataLayer;

        setCookie(null, CASUAL_PRECISION_COOKIE, customerId, {
          maxAge: 30 * 24 * 60 * 60
        });
        (_window$dataLayer = window.dataLayer) === null || _window$dataLayer === void 0 ? void 0 : _window$dataLayer.push({
          customerId: customerId
        });
      }

      if (!customerId && false) {
        throw new Error('<head> missing required attribute `nonce`');
      }
    } else {
      var _window$dataLayer2;

      var _customerId = cookies[CASUAL_PRECISION_COOKIE];
      (_window$dataLayer2 = window.dataLayer) === null || _window$dataLayer2 === void 0 ? void 0 : _window$dataLayer2.push({
        customerId: _customerId
      });
    }
  }, []);

  if (!mocksReady) {
    return null;
  }

  var layoutType = Component === null || Component === void 0 ? void 0 : (_Component$layout = Component.layout) === null || _Component$layout === void 0 ? void 0 : _Component$layout.type;

  if (!isDefined(layoutType) && env === 'local') {
    // eslint-disable-next-line no-console
    console.warn('A default page layout has not been added to the page. If this is not intentional then you should extend your page component with a "layout" property (PageComponent.layout = { ... })');
  }

  var getLayout = function getLayout(type) {
    var _Component$layout2;

    var comp = /*#__PURE__*/_createElement(Component, _objectSpread(_objectSpread({}, pageProps), {}, {
      key: router.route,
      err: err
    }));

    var props = Component === null || Component === void 0 ? void 0 : (_Component$layout2 = Component.layout) === null || _Component$layout2 === void 0 ? void 0 : _Component$layout2.props;

    switch (type) {
      case 'marketing':
        return getMarketingLayout(comp, props);

      case 'aspen':
        return getAspenLayout(comp, props);

      case 'simple':
        return getSimpleLayout(comp, props);

      case 'none':
        return comp;

      default:
        return comp;
    }
  };

  return /*#__PURE__*/_jsx(LinkProvider, {
    baseUrl: pageProps.externalConfigState.baseUrl,
    children: /*#__PURE__*/_jsx(ExternalConfigProvider, {
      value: pageProps.externalConfigState,
      children: /*#__PURE__*/_jsx(PrismicProvider, {
        linkResolver: prismicLinkResolver,
        children: /*#__PURE__*/_jsx(UserContextProvider, {
          children: /*#__PURE__*/_jsxs(StoreIntlProvider, {
            value: (_pageProps$i18nextPag = pageProps.i18nextPageResponse) === null || _pageProps$i18nextPag === void 0 ? void 0 : _pageProps$i18nextPag.config,
            children: [/*#__PURE__*/_jsxs(Head, {
              children: [/*#__PURE__*/_jsx("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
              }), env !== 'test' && /*#__PURE__*/_jsx(FacebookPixel, {
                pixelId: facebook.pixelId,
                trackPageViews: true
              })]
            }), /*#__PURE__*/_jsxs(ThemeProvider, {
              theme: theme,
              children: [/*#__PURE__*/_jsx(SEO, {
                title: "Yohana",
                description: "The Personal Assistant Service for Busy Parents"
              }), /*#__PURE__*/_jsx(GlobalStyles, {}), getLayout(layoutType), /*#__PURE__*/_jsx(AuthGuard, {
                authType: pageProps.authType
              })]
            })]
          })
        })
      })
    })
  });
}; // Forces SSR to always be on which ensures the 404 page is also rendered via SSR.
// This method also sets up a "global" config that is passed down to every page via page props.


StoreApp.getInitialProps = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
    var Component, ctx, externalConfigState, pageProps;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            Component = _ref3.Component, ctx = _ref3.ctx;
            _context2.next = 3;
            return createStoreExternalConfigState(ctx);

          case 3:
            externalConfigState = _context2.sent;
            pageProps = {
              externalConfigState: externalConfigState
            };

            if (!Component.getInitialProps) {
              _context2.next = 12;
              break;
            }

            _context2.t0 = _objectSpread;
            _context2.t1 = _objectSpread({}, pageProps);
            _context2.next = 10;
            return Component.getInitialProps(ctx);

          case 10:
            _context2.t2 = _context2.sent;
            pageProps = (0, _context2.t0)(_context2.t1, _context2.t2);

          case 12:
            return _context2.abrupt("return", {
              pageProps: pageProps
            });

          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x) {
    return _ref4.apply(this, arguments);
  };
}();

export default StoreApp;